import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import ListarViajesPage from "./listar-viaje";
import ViajePage from "./viaje";
import ListarTipoCarguioPage from "./gestionar-tipo-carguio/listar-tipo-carguio";
import TipoCarguioPage from "./gestionar-tipo-carguio/tipo-carguio";
import ListarRegistroCamionesPage from "./gestionar-registro-camiones/listar-registro-camiones";
import ListarKanbanPage from "./gestionar-kanban/listar-kanban";
import KanbanPage from "./gestionar-kanban/kanban";
import ListarKanbanViajePage from "./gestionar-kanban-viaje/listar-kanban";
import KanbanViajePage from "./gestionar-kanban-viaje/kanban";
import ListarAccionesKanbanViajePage from "./gestionar-kanban-viaje/acciones/listar-acciones-kanban";
import AccionesKanbanViajePage from "./gestionar-kanban-viaje/acciones/acciones-kanban";
import ListarKanbanProductoPage from "./gestionar-kanban-producto/listar-kanban";
import KanbanProductoPage from "./gestionar-kanban-producto/kanban";
import ListarAccionesKanbanProductoPage from "./gestionar-kanban-producto/acciones/listar-acciones-kanban";
import AccionesKanbanProductoPage from "./gestionar-kanban-producto/acciones/acciones-kanban";
import ListarTransportadoraPage from "./gestionar-transportadora/listar-transportadora";
import TransportadoraPage from "./gestionar-transportadora/transportadora";
import ListarFormularioViajePage from "./gestionar-formulario-viaje/listar-formulario-viaje";
import FormularioViajePage from "./gestionar-formulario-viaje/formulario-viaje";
import ListarProgramacionCamionesPage from "./gestionar-programacion-camiones/listar-programacion-camiones";
import ProgramacionCamionesPage from "./gestionar-programacion-camiones/programacion-camiones";
import ListarEstadoSolicitudProgramacionCamionesPage from "./gestionar-estado-solicitud-programacion-camiones/listar-estado-solicitud-programacion-camiones";
import LayoutProgramacionCamiones from "../../components/layout-programacion-camiones";
import ListarSolicitudProductoPage from "./gestionar-solicitud-producto/listar-solicitud-producto";
import SolicitudProductoPage from "./gestionar-solicitud-producto/solicitud-producto";
import ListarProgramacionSolicitudProductoPage from "./gestionar-programacion-solicitud-producto/listar-programacion-solicitud-producto";
import ListarProgramacionCamionesKanbanPage from "./gestionar-programacion-solicitud-producto/listar-programacion-camiones-kanban";
import ListarProgramacionProductosKanbanPage from "./gestionar-programacion-solicitud-producto/listar-programacion-productos-kanban";
import ListarAccionesKanbanPage from "./gestionar-kanban/acciones/listar-acciones-kanban";
import AccionesKanbanPage from "./gestionar-kanban/acciones/acciones-kanban";
import ListarEstadoSolicitudProductoPage from "./gestionar-programacion-solicitud-producto/listar-estado-solicitud-producto";
import ListarEstadoSolicitudPage from "./gestionar-estado-solicitud/listar-estado-solicitud";
import EstadoSolicitudPage from "./gestionar-estado-solicitud/estado-solicitud";
import MapaViajePage from "./mapa/mapa-viaje";

const RouterViaje = () => {
  const { path } = useRouteMatch();
  // console.log('routerAdministracion');
  // console.log(path);
  return (
    // <LayoutConfiguracion>
    <Switch>

      <Route exact path={`${path}/listar-tipo-carguio`}>
        <ListarTipoCarguioPage />
      </Route>
      <Route exact path={`${path}/tipo-carguio`}>
        <TipoCarguioPage />
      </Route>

      <Route exact path={`${path}/listar-viajes`}>
        <ListarViajesPage />
      </Route>

      <Route exact path={`${path}/mapa-viaje`}>
        <MapaViajePage />
      </Route>

      <Route exact path={`${path}/viaje`}>
        <ViajePage />
      </Route>

      <Route exact path={`${path}/listar-estado-solicitud`}>
        <ListarEstadoSolicitudPage />
      </Route>
      <Route exact path={`${path}/estado-solicitud`}>
        <EstadoSolicitudPage />
      </Route>

      <Route exact path={`${path}/listar-registro-camiones`}>
        <ListarRegistroCamionesPage />
      </Route>

      <Route exact path={`${path}/listar-kanban`}>
        <ListarKanbanPage />
      </Route>
      <Route exact path={`${path}/kanban`}>
        <KanbanPage />
      </Route>

      <Route exact path={`${path}/listar-acciones-kanban`}>
        <ListarAccionesKanbanPage />
      </Route>
      <Route exact path={`${path}/acciones-kanban`}>
        <AccionesKanbanPage />
      </Route>

      <Route exact path={`${path}/listar-kanban-viaje`}>
        <ListarKanbanViajePage />
      </Route>
      <Route exact path={`${path}/kanban-viaje`}>
        <KanbanViajePage />
      </Route>
      <Route exact path={`${path}/listar-acciones-kanban-viaje`}>
        <ListarAccionesKanbanViajePage />
      </Route>
      <Route exact path={`${path}/acciones-kanban-viaje`}>
        <AccionesKanbanViajePage />
      </Route>

      <Route exact path={`${path}/listar-kanban-producto`}>
        <ListarKanbanProductoPage />
      </Route>
      <Route exact path={`${path}/kanban-producto`}>
        <KanbanProductoPage />
      </Route>
      <Route exact path={`${path}/listar-acciones-kanban-producto`}>
        <ListarAccionesKanbanProductoPage />
      </Route>
      <Route exact path={`${path}/acciones-kanban-producto`}>
        <AccionesKanbanProductoPage />
      </Route>

      <Route exact path={`${path}/listar-formulario-viaje`}>
        <ListarFormularioViajePage />
      </Route>
      <Route exact path={`${path}/formulario-viaje`}>
        <FormularioViajePage />
      </Route>

      <Route exact path={`${path}/listar-transportadora`}>
        <ListarTransportadoraPage />
      </Route>
      <Route exact path={`${path}/transportadora`}>
        <TransportadoraPage />
      </Route>

      <Route exact path={`${path}/listar-programacion-camiones`}>
        <ListarProgramacionCamionesPage />
      </Route>
      <Route exact path={`${path}/programacion-camiones`}>
        <ProgramacionCamionesPage />
      </Route>

      <Route exact path={`${path}/listar-solicitud-producto`}>
        <ListarSolicitudProductoPage />
      </Route>
      <Route exact path={`${path}/solicitud-producto`}>
        <SolicitudProductoPage />
      </Route>
      {/* <Route exact path={`${path}/listar-estado-programacion-solicitud-producto`}>
        <ListarEstadoProgramacionSolicitudProductoPage />
      </Route> */}

      <LayoutProgramacionCamiones>
        <Route exact path={`${path}/listar-estado-solicitud-programacion-camiones`}>
          <ListarEstadoSolicitudProgramacionCamionesPage />
        </Route>

        <Route exact path={`${path}/listar-estado-solicitud-producto`}>
          <ListarEstadoSolicitudProductoPage />
        </Route>

        <Route exact path={`${path}/listar-programacion-solicitud-producto`}>
          <ListarProgramacionSolicitudProductoPage />
        </Route>

        <Route exact path={`${path}/listar-programacion-camiones-kanban`}>
          <ListarProgramacionCamionesKanbanPage />
        </Route>

        <Route exact path={`${path}/listar-programacion-productos-kanban`}>
          <ListarProgramacionProductosKanbanPage />
        </Route>
      </LayoutProgramacionCamiones>

      {/* <Route exact path={`${path}`}>
        <AdministracionIndex />
      </Route> */}

    </Switch>
    // </LayoutConfiguracion>
  );
};

export default RouterViaje;
